import * as React from 'react';
import {
  Avatar,
  Button,
  makeStyles,
  Menu,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Persona,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { defineMessage, useIntl } from 'react-intl';
import { TextLink } from '@foundershub/components';
import { useUserRequired } from '../store';

export function UserMenu() {
  const user = useUserRequired();
  const intl = useIntl();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Menu>
        <MenuTrigger>
          <Button
            appearance="transparent"
            className={classes.button}
            aria-label={intl.formatMessage(usermenu, { name: `${user.first_name} ${user.last_name}` })}
          >
            <Avatar
              color="colorful"
              name={`${user.first_name} ${user.last_name}`}
              image={{ src: user.photo }}
              size={40}
            />
          </Button>
        </MenuTrigger>

        <MenuPopover className={classes.popover}>
          <MenuList className={classes.menu}>
            <MenuItem>
              <Persona
                name={`${user.first_name} ${user.last_name}`}
                secondaryText={user.email}
                size="huge"
                avatar={{
                  image: {
                    src: user.photo,
                  },
                }}
              />
            </MenuItem>
            <MenuDivider />
            {user.accounts && user.accounts.length >= 1 ? (
              <>
                <MenuGroup>
                  {user.accounts.map((account) => {
                    return (
                      <MenuItem key={account.id}>
                        <TextLink href={`/settings/company/${account.id}`} role="link">{`${intl.formatMessage(
                          viewText
                        )} ${account.name}`}</TextLink>
                      </MenuItem>
                    );
                  })}
                </MenuGroup>
              </>
            ) : null}
            <MenuItem>
              <TextLink href="/logout" role="link">
                {intl.formatMessage(signOut)}
              </TextLink>
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
}

const usermenu = defineMessage({ defaultMessage: 'User menu for {name}', description: 'menu label for user settings' });
const signOut = defineMessage({ defaultMessage: 'Sign out', description: 'Link to log out' });
const viewText = defineMessage({ defaultMessage: 'View', description: 'Link to view account profile' });

const useStyles = makeStyles({
  root: {
    rowGap: tokens.spacingVerticalMNudge,
  },
  button: {
    minWidth: '0',
    ':hover': {
      backgroundColor: tokens.colorBrandBackgroundHover,
    },
  },
  popover: {
    minWidth: '320px',
    ...shorthands.padding(tokens.spacingHorizontalL),
  },
  menu: {
    ...shorthands.margin(0),
  },
});
